<template>
    <div class="separator-block" :style="separatorStyles">
        <div class="separator-line"></div>
    </div>
</template>

<script>
export default {
    name: 'SeparatorBlock',
    props: {
        block: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            showProperties: false
        }
    },
    computed: {
        separatorStyles() {
            return {
                margin: this.block.styles?.margin || '20px 0',
                textAlign: 'center'
            }
        }
    },
    methods: {
        updateStyles() {
            this.$emit('update', {
                styles: { ...this.block.styles }
            })
        },

        toggleProperties() {
            this.showProperties = !this.showProperties
        }
    }
}
</script>

<style lang="scss" scoped>
.separator-block {
    border: 1px solid transparent;
    border-radius: 4px;
    transition: all 0.2s;

    &:hover {
        border-color: #e0e0e0;
    }
}

.block-header {
    display: flex;
    justify-content: flex-end;
    padding: 4px 8px;
    background: #f5f5f5;
    border-radius: 4px 4px 0 0;
    opacity: 0;
    transition: opacity 0.2s;

    .separator-block:hover & {
        opacity: 1;
    }
}

.properties-toolbar {
    background: #f8f9fa;
    padding: 12px;
    border-bottom: 1px solid #e0e0e0;

    .v-text-field {
        margin-bottom: 0;
    }
}

.separator-line {
    height: 1px;
    background: #e0e0e0;
    width: 100%;
    position: relative;

    &::before {
        content: '';
        position: absolute;
        top: -5px;
        left: 50%;
        transform: translateX(-50%);
        width: 10px;
        height: 10px;
        background: #e0e0e0;
        border-radius: 50%;
    }
}
</style>
